import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/lib/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#0169EE",
        accent: "#FF9C00",
        grey: '#F0F0F0',
      },
      dark: {
        primary: "#0169EE",
        accent: "#FF9C00",
        grey: '#F0F0F0',
        darkGrey: "#212121",
        black: "#121212"
      },
    },
  },
  lang: {
    locales: { en },
    current: 'en',
  },
});
